import {
  GridSingleChoiceQuestionConfig,
  GridSingleChoiceQuestionSettings,
} from '@hyper-inferno/grid-single-choice-core';
import {
  QuestionHandler,
  ITransformationContext,
} from '@hyper-inferno/survey-bot-core';
import {
  Element,
  QuestionAnswerObject,
  SurveyElement,
} from '@hyper-inferno/survey-elements-core';

interface GridSingleChoiceElementBundle extends Element {
  config: GridSingleChoiceQuestionSettings;
}

interface GridCell {
  row: number;
  col: number;
  val: string;
}
export class GridSingleChoiceHandler
  implements QuestionHandler<GridSingleChoiceQuestionConfig>
{
  async buildConfig(
    el: GridSingleChoiceElementBundle,
    ctx: ITransformationContext,
  ): Promise<GridSingleChoiceQuestionConfig> {
    // TODO remove the filters after answer filtering is enabled for grid
    const rows = await ctx.listBuilding.getOptionsByListId(
      el.config.row_list_id,
      ctx,
      el.config.row_list_randomize_options,
    );

    const columns = await ctx.listBuilding.getOptionsByListId(
      el.config.column_list_id,
      ctx,
      el.config.column_list_randomize_options,
    );

    return {
      ...el.config,
      rows,
      columns,
    };
  }

  getValue(
    el: SurveyElement,
    response: QuestionAnswerObject,
  ): { [key: number]: number[] } {
    const selections = response[el.name] as GridCell[] | undefined;

    if (!Array.isArray(selections)) {
      return {};
    }

    const result: { [key: number]: number[] } = {};

    for (const item of selections) {
      if (item.val !== 'selected') {
        continue;
      }

      // Single grid -> only one selection per row
      result[Number(item.row)] = [Number(item.col)];
    }
    return result;
  }
}
